import { trpc } from "../trpc";

interface Input {
  folderId?: string; // used for cache invalidation in mutations
}

export const useTransferInterface = (input?: Input) => {
  const { folderId } = input || {};
  const utils = trpc.useUtils();

  return trpc.interface.transferInterface.useMutation({
    onSettled: () => {
      utils.interface.list.invalidate();

      if (folderId) {
        utils.asset.getHydratedFolderAssets.invalidate({ folderId });
      }

      // Invalidate permissions cache so kebab menu reflects new owner's permissions
      utils.permission.checkPermissions.invalidate();
    },
  });
};
